"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestResultsSectionHeaderContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestHeaderLayout_medium_large_1 = require("./ContestHeaderLayout.medium-large");
var ContestHeaderLayout_small_1 = require("./ContestHeaderLayout.small");
var layouts = {
    small: ContestHeaderLayout_small_1.ContestHeaderLayoutSmall,
    medium: ContestHeaderLayout_medium_large_1.ContestHeaderLayoutMediumLarge,
    large: ContestHeaderLayout_medium_large_1.ContestHeaderLayoutMediumLarge,
};
var ContestResultsSectionHeaderContainer = /** @class */ (function (_super) {
    __extends(ContestResultsSectionHeaderContainer, _super);
    function ContestResultsSectionHeaderContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContestResultsSectionHeaderContainer.prototype.render = function () {
        var _a = this.props, emitTrackingEvent = _a.emitTrackingEvent, onContestFilterChange = _a.onContestFilterChange, queryOptions = _a.queryOptions;
        var _b = this.props.resultsContext, isFallback = _b.isFallback, totalItemCount = _b.totalItemCount;
        var breakpoint = this.props.layout.breakpoint;
        var ContestHeaderLayout = layouts[breakpoint];
        // How would contestInfo be null, anyway?
        var initialTimeRemaining = queryOptions.contestInfo ? queryOptions.contestInfo.endTime - Date.now() : null;
        var layoutProps = __assign(__assign({}, queryOptions), { emitTrackingEvent: emitTrackingEvent, isFallback: isFallback, totalItemCount: totalItemCount, onContestFilterChange: onContestFilterChange, initialTimeRemaining: initialTimeRemaining !== null && initialTimeRemaining !== void 0 ? initialTimeRemaining : 0 });
        return (0, jsx_runtime_1.jsx)(ContestHeaderLayout, __assign({}, layoutProps));
    };
    ContestResultsSectionHeaderContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            layout: Contexts_1.ILayoutContext,
        })
    ], ContestResultsSectionHeaderContainer);
    return ContestResultsSectionHeaderContainer;
}(React.Component));
exports.ContestResultsSectionHeaderContainer = ContestResultsSectionHeaderContainer;
//# sourceMappingURL=ContestResultsSectionHeaderContainer.js.map